import { BaseEntityService } from "./base-entity.service";
import { Injectable, Optional } from "@angular/core";

import { AngularFirestore, QueryFn } from "@angular/fire/firestore";
import { AssignmentProposal } from './assignment-proposal.model';
import { Observable } from 'rxjs';
import { User } from './user.model';

export class AssignmentProposalService extends BaseEntityService<
  AssignmentProposal
  > {
  constructor(db: AngularFirestore, itineraryId?: string) {
    super(db, AssignmentProposal, (itineraryId ? ("itineraries/" + itineraryId + "/") : null), "assignment-proposals");
  }

  listForUser(user: User): Observable<AssignmentProposal[]> {
    this.log("listForUser", user.id);
    return this.list(ref => ref.where('user', '==', this.db.doc("/users/" + user.id).ref));
  }

  listCollectionGroupPendingForUser(user: User): Observable<AssignmentProposal[]> {
    this.log("listCollectionGroupPendingForUser", user.id);
    return this.list(ref => ref.where('user', '==', this.db.doc("/users/" + user.id).ref).where('pending', '==', true));
  }
}

@Injectable({
  providedIn: "root"
})
export class AssignmentProposalServiceFactory {
  constructor(private db: AngularFirestore) {

  }

  create(itineraryId: string): AssignmentProposalService {
    return new AssignmentProposalService(this.db, itineraryId);
  }
}
